import { render } from "./SidebarComponent.vue?vue&type=template&id=f0c7dcee&scoped=true"
import script from "./SidebarComponent.vue?vue&type=script&lang=js"
export * from "./SidebarComponent.vue?vue&type=script&lang=js"

import "./SidebarComponent.vue?vue&type=style&index=0&id=f0c7dcee&scoped=true&lang=css"
import "./SidebarComponent.vue?vue&type=style&index=1&id=f0c7dcee&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0c7dcee"]])

export default __exports__